import React from 'react';
import styled from 'App/styled';


const SocialMediaWrap = styled.div`
  background-color: ${({ theme }) => theme.footerBak};
  padding: 20px 0 0 10px;
  margin-top: 9px;
`;

const SocialMediaTitle = styled.div`
  ${({ theme }) => theme.typography.subTitleSmall};
  text-align: center;
  text-transform: lowercase;

  :first-letter {
    text-transform: uppercase;
  }
  :firstline {
    text-transform: uppercase;
  }
`;

const SocialMediaList = styled.ul`
  margin: 6px 0 0;
  list-style: none;
  display: flex;
  justify-content: center;
`;

const SocialMediaItems = styled.li`
  margin: 0;
`;

const SocialMediaLink = styled.a`
  display: inline-block;
  padding: ${({ theme }) => theme.spacing.spacing20};
`;

interface SocialLinksProps {
  socialLinksEnabled: boolean;
  socialLinks: {text: string, social: [{[key:string]:string}]};
};

const SocialMediaLinks = ({ socialLinksEnabled, socialLinks }: SocialLinksProps) => {
  const { social } = socialLinks || {};
  if (!socialLinksEnabled) return null;

  return (
    <SocialMediaWrap>
      <SocialMediaTitle>
        {socialLinks?.text}
      </SocialMediaTitle>

      <SocialMediaList>
        {
          social?.map((socialItem, index) => (
            <SocialMediaItems key={`socialItem${index}`}>
              <SocialMediaLink href={socialItem?.link} target="_blank" rel="noopener noreferrer">
                <img src={socialItem?.imgUrl} alt={socialItem?.title}/>
              </SocialMediaLink>
            </SocialMediaItems>
          ))
        }
      </SocialMediaList>
    </SocialMediaWrap>
  );
};

export default SocialMediaLinks;

